import { Environment } from './environment-variables';

export const defaultFormatString = `dl-vlaanderen-public-${Environment}-default-format`;
export const emailInformationKey = `dl-vlaanderen-public-${Environment}-download-email-info`;
export const latestLocation = `dl-vlaanderen-public-${Environment}-latest-location`;
export const cookieKey = `dl-vlaanderen-public-${Environment}-cookie-consent`;
export const defaultReferenceSystemString = `dl-vlaanderen-public-${Environment}-default-reference-system`;
export const closedNotificationsKey = `dl-vlaanderen-public-${Environment}-closed-notifications`
